import { render, staticRenderFns } from "./GoodsItem.vue?vue&type=template&id=166547eb&scoped=true"
import script from "./GoodsItem.vue?vue&type=script&lang=ts"
export * from "./GoodsItem.vue?vue&type=script&lang=ts"
import style0 from "./GoodsItem.vue?vue&type=style&index=0&id=166547eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166547eb",
  null
  
)

export default component.exports